import { render, staticRenderFns } from "./AddAssigned.vue?vue&type=template&id=6440039f"
import script from "./AddAssigned.vue?vue&type=script&lang=js"
export * from "./AddAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports